import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OptionsEnum } from 'src/app/model/enums/OptionsEnum';
import { EnumConverterService } from 'src/app/services/EnumConverterService';

@Component({
  selector: 'app-application-insurance',
  templateUrl: './application-insurance.component.html',
  styleUrls: ['./application-insurance.component.css']
})
export class ApplicationInsuranceComponent {
  @Input()
  isSecondInsured: boolean;

  @Input()
  applicationFormGroup: FormGroup;

  OptionsEnum = OptionsEnum;

  yesNoList = this.enumConverterService.toBaseList('OptionsEnum', OptionsEnum);

  constructor(private enumConverterService: EnumConverterService) { }
}
